type TrustpilotVerificationMetaProps = {
  trustpilotVerificationId: string;
};

export function TrustpilotVerificationMeta({ trustpilotVerificationId }: TrustpilotVerificationMetaProps) {
  if (!trustpilotVerificationId) {
    return null;
  }

  return (
    <meta
      key="trustpilot-verification"
      name="trustpilot-one-time-domain-verification-id"
      content={trustpilotVerificationId}
    />
  );
}
